"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useEffect, useRef } from "react";
export default function FilmServicesOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const parallaxRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (parallaxRef.current) {
        const scrollY = window.scrollY;
        const offset = scrollY * 0.3;
        parallaxRef.current.style.transform = `translateY(${offset}px)`;
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section ref={ref} className={`relative min-h-screen w-full overflow-hidden transition-all duration-[var(--duration-medium)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
      <div className="grid lg:grid-cols-2 min-h-screen">
        {}
        <div className="flex flex-col justify-center px-6 py-12 md:px-12 lg:px-16 xl:px-24 bg-background">
          <div className="max-w-2xl">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-6 leading-tight">
              Film Project Development & Packaging
            </h1>
            <p className="text-lg md:text-xl text-foreground/80 mb-8 leading-relaxed">
              Transform your creative vision into a fundable production. We provide systematic project structuring, strategic packaging, and essential industry connections to help filmmakers secure production funding efficiently and professionally.
            </p>
            <Link to="/ContactPage">
              <Button size="lg" className="transition-all duration-[var(--duration-fast)] hover:scale-[1.02] hover:shadow-medium">
                Start Your Project
              </Button>
            </Link>
          </div>
        </div>

        {}
        <div className="relative min-h-[50vh] lg:min-h-screen overflow-hidden">
          <div ref={parallaxRef} className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1517061/img/bustling_film_set_production.png)] transition-transform will-change-transform" style={{
          height: "120%",
          top: "-10%"
        }} />
          <div className="absolute inset-0 bg-gradient-to-r from-background/20 to-transparent" />
        </div>
      </div>
    </section>;
}